import React from 'react';

const MandatoryMark = () => {
  return <span className="mandatory-field">*</span>;
};

export default React.memo(MandatoryMark);
